import { Box } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const Message = styled(Box)(({ theme }) => ({
  background: theme.colors.white,
  borderRadius: "25px",
  bottom: "-24px",
  color: theme.colors.black,
  // This message will only be shown while dragging a block.
  // See '.fill-in-gap-tip' style override.
  display: "none",
  fontSize: "12px",
  fontStyle: "italic",
  left: "-3px",
  padding: "2px 5px",
  position: "fixed",
}));

export default function FillInGapTip() {
  return <Message className="fill-in-gap-tip">Hold &apos;Shift&apos; to use fill-in-the-gap mode</Message>;
}
